import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// DELETE MEMBER FROM ENTERPRISE
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestRemoveMemberFromEnterprise = packet => {
  return {
    type: 'REQUEST_REMOVE_MEMBER',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveRemoveMemberFromEnterpriseSuccess = data => ({
  type: 'RECEIVE_REMOVE_MEMBER_SUCCESS',
  data
})

export const receiveRemoveMemberFromEnterpriseFail = data => ({
  type: 'RECEIVE_REMOVE_MEMBER_FAIL',
  data
})

export const tryToRemoveMemberFromEnterprise = packet => dispatch => {
  dispatch(requestRemoveMemberFromEnterprise(packet));
  
  return fetch('/api/members/from-enterprise/' + packet.id, {
      method: 'delete',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveRemoveMemberFromEnterpriseSuccess(json));
    })
    .catch(e => {
      revokeTokenHandler(e);
      dispatch(receiveRemoveMemberFromEnterpriseFail({errors:e, lastSubmit: packet}));
    })
}


// WEBPACK FOOTER //
// ./src/actions/members/a.m.DELETE.from-enterprise.js